import $ from 'jquery'
import slick from 'slick-carousel'
import LazyLoad from "vanilla-lazyload"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
gsap.registerPlugin(ScrollTrigger)
import ModalVideo from 'modal-video'
import 'jquery-modal'

/* SETUP SLICK
  ----------------------------- */
export const setupSlideshow = (el, type = 'basic', slidesNumber = 1) => {
  const $el = $(el);
  const opts = {
    basic: {
      autoplay: true,
      arrows: false,
    },
    homeMain: {
      autoplay: true,
      arrows: false,
      fade: true,
      // asNavFor: '.section--home-hero .section__numbers',
    },
    homeNav: {
      arrows: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      focusOnSelect: true,
      variableWidth: true,
      asNavFor: '.section--home-hero .section__slider',
    },
    product: {
      arrows: false,
      dots: true,
    },
    productRelated: {
      variableWidth: true,
      arrows: false,
      infinite: false,
    }
  }

  $el.slick(opts[type])
}

/* LAZY LOAD
  ----------------------------- */
export const lazyLoad = () => {
  const lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
    data_src: "src",
  })
}

/* SMOOTH SCROLL
  ----------------------------- */
export const smoothScroll = () => {
  $('a[href*="#"]:not([href="#"]):not([href="#top"]):not([target="_blank"]):not([href*="#modal"]):not([href="#building"]):not([href="#packaging"]):not([href="#materials"])').click(function(e) {
    const target = $(this.hash)
    if (target.length > 1) e.preventDefault()
    $('html, body').animate({ scrollTop: target.offset().top-100 }, 1000)
  })

  $("a[href='#top']").click(function(e) {
    e.preventDefault()
    $('html, body').animate({ scrollTop: 0 }, 800)
  })
}

/* HEADER SETUP
  ----------------------------- */
export const menuOverlay = () => {
  const toggle = $('.header__toggle')
  const bar = $('.header__toggle .bar')
  const overlay = $('.header--offcanvas, .header__inner, .content-area, body')
  const link = $('.header--offcanvas a:not([href="#"])');
  const header = $('.header--main');

  toggle.on('click', function () {
    overlay.toggleClass('open')
    bar.toggleClass('animate')
    toggle.toggleClass('open')
  })

  link.on('click', function () {
    overlay.removeClass('open')
    bar.removeClass('animate')
    toggle.removeClass('open')
  })

  $(document).scrollTop() > 200 ?
    header.addClass('sticky') :
    header.removeClass('sticky')

  $(window).scroll(function(e) {
    $(document).scrollTop() > 200 ?
      header.addClass('sticky') :
      header.removeClass('sticky')
  })

  // SUB MENU TRIGGER
  $('.menu--primary > .menu-item-has-children,.menu--primary .menu-item-megamenu').append('<span class="sub-menu-icon inline-block pt2 pr2 ml1 pointer"></span>')
  $('.menu--primary > .menu-item-has-children .sub-menu-icon').on('click', function() {
    console.log('clicked')
    $(this).parent().toggleClass('open').siblings().removeClass('open')
  })

  // INSERT SEARCH IN MENU
  $('.header__search-wrapper').insertBefore('.header__menu-wrapper .menu--primary .menu-item-contacts-dark')

  // MEGAMENU
  $('.menu--primary .menu-item-megamenu,.section--home-hero .section__cta-block:has(a[href^="#"])').on('click', function (e) {
    e.preventDefault()
    var megamenu = $(this).find('a').attr('href').replace('#', '')

    if ($(this).hasClass('open')) {
      $(this).removeClass('open')
      $('.header--overlay,.header__inner').removeClass('open')
      $('.header--megamenu-' + megamenu).slideUp()
    } else {
      $('.menu--primary .menu-item-megamenu,.section--home-hero .section__cta-block').removeClass('open')
      $('.header--megamenu').slideUp()
      $(this).addClass('open')
      $('.header--overlay,.header__inner').addClass('open')
      $('.header--megamenu-' + megamenu).slideDown()
    }
  })

  $('.header--overlay,.header__toggle').on('click', function () {
    $('.header--overlay,.menu--primary .menu-item-megamenu,.section--home-hero .section__cta-block,.header__inner').removeClass('open')
    $('.header--megamenu').slideUp()
  })
}

/* SETUP MODALVIDEO
  ----------------------------- */
export const setupModalVideo = () => {
  if ($('.js-modal-btn').length > 0 || $('.js-modal-btn-vimeo').length > 0) {
    new ModalVideo('.js-modal-btn')
    new ModalVideo('.js-modal-btn-vimeo', { channel: 'vimeo' })
  }
}

/* SETUP ACCORDION
  ----------------------------- */
export const setupAccordion = () => {
  $('.accordion').each(function() {
    const $title = $(this).find('.accordion-title')
    const $body = $(this).find('.accordion-body')

    $title.on('click', function() {
      $(this).parent().toggleClass('open')
      $body.slideToggle()
    })
  })
}

/* LIST SECTION IMAGES ON MOUSEOVER
  ----------------------------- */
export const homeCategoriesMouseover = () => {
  $('.section--home-products .section__category').each(function () {
    $(this).on('mouseenter', function () { $('#' + $(this).data('category')).addClass('active') })
    $(this).on('mouseleave', function () { $('#' + $(this).data('category')).removeClass('active') })
  })
}

/* PRODUCTS TABS
  ----------------------------- */
export const productsTabs = () => {
  $('.section__showcase-tabs-wrapper').each(function () {
    const $tabs = $(this).find('.section__tab')
    const $content = $(this).find('.section__tab-content')

    $tabs.on('click', function () {
      const tabId = $(this).data('tab')
      $tabs.removeClass('active')
      $(this).addClass('active')

      $content.removeClass('active')
      $('#' + tabId).addClass('active')
    })
  })
}

/* TOGGLE SIDEBAR
  ----------------------------- */
export const toggleSidebar = () => {
  const $sidebar = $('.header--sidebar-wrapper')
  const $toggle = $sidebar.find('.block__toggle')

  $toggle.on('click', function () {
    $sidebar.toggleClass('open')
  })
}